import React from 'react'
import { useTranslation } from '../../../../../common/hooks'
import { Button, Stack, Typography } from '@mui/material'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import { useBlackButtonStyle } from '../../../../../utils/styles/useBlackButtonStyle'
import { More } from '../../../../../common/components/BetmenList/BetmenListActions'
import EditIcon from '@mui/icons-material/Edit'

interface PatientDetailsSectionHeaderProps {
  icon: React.ReactNode
  title: string
  hasData?: boolean
  extraHeaderInfo?: string
  onAdd?: () => void
  onEdit?: () => void
}

export const PatientDetailsSectionHeader: React.FC<
  PatientDetailsSectionHeaderProps
> = ({ icon, title, hasData = true, extraHeaderInfo, onAdd, onEdit }) => {
  const { t } = useTranslation()
  const classes = useBlackButtonStyle()

  return (
    <Stack direction="row" alignItems="center" gap={1} px={3}>
      {icon}
      {title}
      {!hasData && (
        <Typography variant="italic">
          {' '}
          ({t('doctor:patientProfile.noData')})
        </Typography>
      )}
      {extraHeaderInfo && (
        <Typography
          marginLeft="auto"
          variant="body2"
          fontWeight={400}
          color="grey.400"
        >
          {extraHeaderInfo}
        </Typography>
      )}

      {onAdd && (
        <Button
          variant="text"
          color="primary"
          sx={{ marginLeft: 'auto', paddingX: '4px' }}
          startIcon={<AddCircleOutlineIcon />}
          onClick={onAdd}
        >
          {t('doctor:patientProfile.addButton')}
        </Button>
      )}

      {onEdit && (
        <More>
          <Button
            classes={{ textPrimary: classes.textPrimary }}
            variant="text"
            startIcon={<EditIcon />}
            sx={{ justifyContent: 'flex-start' }}
            onClick={onEdit}
          >
            {t('common:edit')}
          </Button>
        </More>
      )}
    </Stack>
  )
}
